import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import SearchDropdown from './search_dropdown'

type SearchMenuProps = {
  // Add your prop types here
}

const SearchMenu: React.FunctionComponent<SearchMenuProps> = () => {
  const { t } = useTranslation("common")

  const [isOpen, setOpen] = useState(false)
  const [searchTimeout, setSearchTimeout] = useState<number | undefined>(undefined)

  const [query, setQuery] = useState<string | null>(null)

  useEffect(() => {
    // Debounce search
    clearTimeout(searchTimeout)

    if (!query) {
      setOpen(false)
      return
    }

    const t = setTimeout(() => setOpen(true), 3000)

    // @ts-ignore
    setSearchTimeout(t)
  }, [query])

  return (
    <Container>
      <Input type="text" placeholder={t("header.search")} onChange={ev => setQuery(ev.target.value)} />
      <SearchDropdown isOpen={isOpen} query={query} onClick={() => setOpen(false)}/>
      <Link to={`/search?q=${query}`}>
        <SearchIcon src={require("../images/search.svg")} />
      </Link>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  display: none;

  margin-right: 20px;

  ${up('tablet')} {
    display: grid;
  }
`

const Input = styled.input`
  padding: 10px 40px 10px 20px;

  outline: none;
  box-shadow: none;
  border-radius: 333px;
  border: 2px solid ${p => p.theme.colors.serviceGray};

  &:focus {
    border: 2px solid ${p => p.theme.colors.accent};
  }
`

const SearchIcon = styled.img`
  position: absolute;
  right: 10px;
  top: 10px;

  width: 20px;
  height: 20px;

  &:hover {
    filter: brightness(0) saturate(100%) invert(37%) sepia(44%) saturate(1904%) hue-rotate(219deg) brightness(89%) contrast(88%);
  }

  cursor: pointer;
`

export default SearchMenu